import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { apiUrl } from "../../../config/config";

// const dummy = [
//   {
//     id: "37",
//     address_id: "N+C10378&HeadOffice",
//     sap_code: "N+C10378",
//     address_name: "HeadOffice",
//     address_line_1: "456 Dummy Road",
//     address_line_2: null,
//     address_city: "Adelaide",
//     address_postcode: "2000",
//     address_state: "NSW",
//     is_default: "1",
//     created_at: "2025-09-03 19:39:13",
//     updated_at: "2025-09-04 00:50:16",
//   },
//   {
//     id: "38",
//     address_id: "N+C10378&Headquarter",
//     sap_code: "N+C10378",
//     address_name: "Headquarter",
//     address_line_1: "Our Headquarter Dummy Road",
//     address_line_2: null,
//     address_city: "Adelaide",
//     address_postcode: "2000",
//     address_state: "NSW",
//     is_default: "0",
//     created_at: "2025-09-03 19:50:09",
//     updated_at: "2025-09-04 00:50:16",
//   },
// ];

export const useGetAddress = (fh_id) => {
  const URL = `${apiUrl}/acc/v1/funeral-home/${fh_id}/addresses`;
  const fn = async () => {
    const res = await axios.get(URL);

    const addresses = res?.data?.data?.addresses || [];
    // if (data.data.addresses.length === 0)
    return [...addresses];

    // return [...dummy];
  };

  return useQuery([URL], fn, {
    enabled: !!fh_id,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
